export const TRANSACTION_STATUS_PENDING = "PENDING";
export const TRANSACTION_STATUS_PAID = "PAID";
export const TRANSACTION_STATUS_VOID = "VOID";

export const TRANSACTION_STATUSES = [
  { id: TRANSACTION_STATUS_PENDING, name: "Pendiente" },
  { id: TRANSACTION_STATUS_VOID, name: "Nula" },
  { id: TRANSACTION_STATUS_PAID, name: "Pagada" },
];
